
import Sidebar from './Sidebar';
import Header from './Header';

export default function Layout({ sidebar, children }) {
	const Sidebar = sidebar;
	
	return <div className="container page">
		<Sidebar />
		<div>
			<Header />
			{ children }
		</div>
	</div>;
}

